export const PERMISSIONS = {
  NEWS: {
    ADD_NEWS_ARTICLE: "add_news_article",
    VIEW_ALL_NEWS_ARTICLES: "view_all_news_articles",
    EDIT_NEWS_ARTICLE: "edit_news_article",
    DELETE_NEWS_ARTICLE: "delete_news_article",
    TOGGLE_ACTIVE_NEWS_ARTICLE: "toggle_active_news_article",
    TOGGLE_FEATURED_NEWS_ARTICLE: "toggle_featured_news_article",
  },
  SERVICE: {
    ADD_SERVICE: "add_service",
    VIEW_ALL_SERVICES: "view_all_services",
    EDIT_SERVICE: "edit_service",
    DELETE_SERVICE: "delete_service",
    TOGGLE_ACTIVE_SERVICE: "toggle_active_service",
    TOGGLE_FEATURED_SERVICE: "toggle_featured_service",
  },
  INVESTMENT: {
    ADD_INVESTMENT: "add_investment",
    VIEW_ALL_INVESTMENTS: "view_all_investments",
    EDIT_INVESTMENT: "edit_investment",
    DELETE_INVESTMENT: "delete_investment",
    TOGGLE_ACTIVE_INVESTMENT: "toggle_active_investment",
    TOGGLE_FEATURED_INVESTMENT: "toggle_featured_investment",
  },
  FAQ: {
    ADD_FAQ: "add_faq",
    VIEW_ALL_FAQS: "view_all_faqs",
    EDIT_FAQ: "edit_faq",
    DELETE_FAQ: "delete_faq",
    TOGGLE_ACTIVE_FAQ: "toggle_active_faq",
    TOGGLE_FEATURED_FAQ: "toggle_featured_faq",
  },
  FAQ_CATEGORY: {
    ADD_FAQ_CATEGORY: "add_faq_category",
    VIEW_ALL_FAQ_CATEGORIES: "view_all_faq_categories",
    EDIT_FAQ_CATEGORY: "edit_faq_category",
    DELETE_FAQ_CATEGORY: "delete_faq_category",
    TOGGLE_ACTIVE_FAQ_CATEGORY: "toggle_active_faq_category",
    TOGGLE_DEFAULT_FAQ_CATEGORY: "toggle_default_faq_category",
  },
  NOTIFICATION: {
    ADD_NOTIFICATION: "add_notification",
    VIEW_ALL_NOTIFICATIONS: "view_all_notifications",
    EDIT_NOTIFICATION: "edit_notification",
    DELETE_NOTIFICATION: "delete_notification",
    TOGGLE_ACTIVE_NOTIFICATION: "toggle_active_notification",
  },
  PHOTO_MEDIA: {
    ADD_PHOTO: "add_photo",
    VIEW_ALL_PHOTOS: "view_all_photos",
    EDIT_PHOTO: "edit_photo",
    DELETE_PHOTO: "delete_photo",
    TOGGLE_ACTIVE_PHOTO: "toggle_active_photo",
    TOGGLE_FEATURED_PHOTO: "toggle_featured_photo",
  },
  VIDEO_MEDIA: {
    ADD_VIDEO: "add_video",
    VIEW_ALL_VIDEOS: "view_all_videos",
    EDIT_VIDEO: "edit_video",
    DELETE_VIDEO: "delete_video",
    TOGGLE_ACTIVE_VIDEO: "toggle_active_video",
  },
  MOVIE_MEDIA: {
    ADD_MOVIE: "add_movie",
    VIEW_ALL_MOVIES: "view_all_movies",
    EDIT_MOVIE: "edit_movie",
    DELETE_MOVIE: "delete_movie",
    TOGGLE_ACTIVE_MOVIE: "toggle_active_movie",
  },
  TESTIMONIAL: {
    ADD_TESTIMONIAL: "add_testimonial",
    VIEW_ALL_TESTIMONIALS: "view_all_testimonials",
    EDIT_TESTIMONIAL: "edit_testimonial",
    DELETE_TESTIMONIAL: "delete_testimonial",
    TOGGLE_ACTIVE_TESTIMONIAL: "toggle_active_testimonial",
    TOGGLE_FEATURED_TESTIMONIAL: "toggle_featured_testimonial",
  },
  CAREER: {
    ADD_CAREER: "add_career",
    VIEW_ALL_CAREERS: "view_all_careers",
    EDIT_CAREER: "edit_career",
    DELETE_CAREER: "delete_career",
    TOGGLE_ACTIVE_CAREER: "toggle_active_career",
    TOGGLE_FEATURED_CAREER: "toggle_featured_career",
  },
  INQURIES: {
    GET_ALL_GENERAL_INQUIRIES: "get_all_general_inquires",
    GET_ALL_BUSINESS_INQUIRIES: "get_all_business_inquires",
    GET_ALL_SERVICE_INQUIRIES: "get_all_service_inquires",
    GET_ALL_BUSINESS_CLUB_INQUIRIES: "get_all_business_club_inquires",
    GET_ALL_CAREER_INQUIRIES: "get_all_career_inquires",
    GET_ALL_PARTNERSHIP_INQUIRIES: "get_all_partnership_inquires",
    GET_ALL_CONSULTING_INQUIRIES: "get_all_consulting_inquires",
  },
  FILE: {
    ADD_FILE: "add_file",
    VIEW_ALL_FILES: "view_all_files",
    DELETE_FILE: "delete_file",
    DOWNLOAD_FILE: "download_file",
    TOGGLE_DEFAULT_FILE: "toggle_default_file",
    FILE_DETAILS: "file_details",
  },
  MENU_MANAGEMENT: {
    ADD_MENU: "add_menu",
    EDIT_MENU: "edit_menu",
    DELETE_MENU: "delete_menu",
    VIEW_ALL_MENUS: "view_all_menus",
    TOGGLE_PRODUCT_MENU: "toggle_product_menu",
    TOGGLE_ACTIVE_MENU: "toggle_active_menu",
  },
  CMS_SETUP: {
    ADD_PAGE: "add_page",
    VIEW_ALL_PAGES: "view_all_pages",
    EDIT_PAGE: "edit_page",
    EDIT_PAGE_SECTIONS: "edit_page_sections",
    TOGGLE_ACTIVE_PAGE: "toggle_active_page",
  },
  LANGUAGE: {
    ADD_LANGUAGE: "add_language",
    VIEW_ALL_LANGUAGES: "view_all_languages",
    EDIT_LANGUAGE: "edit_language",
    DELETE_LANGUAGE: "delete_language",
    TOGGLE_ACTIVE_LANGUAGE: "toggle_active_language",
    TOGGLE_RTL_LANGUAGE: "toggle_rtl_language",
    TOGGLE_DEFAULT_LANGUAGE: "toggle_default_language",
  },
  WEBSITE_SETUP: {
    HEADER_SETUP: "header_setup",
    FOOTER_SETUP: "footer_setup",
    GENERAL_SETTINGS: "general_settings",
  },
  STAFF: {
    ADD_STAFF: "add_staff",
    VIEW_ALL_STAFFS: "view_all_staffs",
    EDIT_STAFF: "edit_staff",
    DELETE_STAFF: "delete_staff",
    ADD_STAFF_ROLE: "add_staff_role",
    VIEW_STAFF_ROLES: "view_staff_roles",
    EDIT_STAFF_ROLE: "edit_staff_role",
    DELETE_STAFF_ROLE: "delete_staff_role",
  },

  // ================ NOT WORKING ================

  COMAPNY_LISTING: {
    ADD_COMPANY: "add_company",
    VIEW_ALL_COMPANY: "view_all_company",
    EDIT_COMPANY: "edit_company",
    DELETE_COMPANY: "delete_company",
    TOGGLE_ACTIVE_COMPANY: "toggle_active_company",
  },

  NEWS_CATEGORY: {
    ADD_NEWS_CATEGORY: "add_news_category",
    VIEW_ALL_NEWS_CATEGORIES: "view_all_news_categories",
    EDIT_NEWS_CATEGORY: "edit_news_category",
    DELETE_NEWS_CATEGORY: "delete_news_category",
    TOGGLE_ACTIVE_NEWS_CATEGORY: "toggle_active_news_category",
    TOGGLE_FEATURED_NEWS_CATEGORY: "toggle_featured_news_category",
    TOGGLE_DEFAULT_NEWS_CATEGORY: "toggle_default_news_category",
  },
  CONTACTS: {
    ADD_CONTACT: "add_contact",
    VIEW_ALL_CONTACTS: "view_all_contacts",
    VIEW_ALL_CONTACT_QUERIES: "view_all_contact_queries",
    EDIT_CONTACT: "edit_contact",
    DELETE_CONTACT: "delete_contact",
    DELETE_CONTACT_QUERY: "delete_contact_query",
    TOGGLE_ACTIVE_CONTACT: "toggle_active_contact",
    TOGGLE_ACTIVE_CONTACT_FORM: "toggle_active_contact_form",
    TOGGLE_FEATURED_CONTACT: "toggle_featured_contact",
  },

  COURSES: {
    ADD_COURSE: "add_course",
    VIEW_ALL_COURSES: "view_all_courses",
    EDIT_COURSE: "edit_course",
    DELETE_COURSE: "delete_course",
    TOGGLE_ACTIVE_COURSE: "toggle_active_course",
    TOGGLE_FEATURED_COURSE: "toggle_featured_course",
  },
  PACKAGES: {
    ADD_PACKAGE: "add_package",
    VIEW_ALL_PACKAGES: "view_all_packages",
    EDIT_PACKAGE: "edit_package",
    DELETE_PACKAGE: "delete_package",
    TOGGLE_ACTIVE_PACKAGE: "toggle_active_package",
    TOGGLE_FEATURED_PACKAGE: "toggle_featured_package",
  },
};
